<template>
  <div>
    <section-collapseable
      v-if="hasFollowUpSequenceFeature"
      title="Follow Up Sequences"
      :sub-title="totalFollowUps"
      :class="{'is_in_follow_up': activeFollowUps.length}"
      :collapseable="!!otherFollowUps.length"
      :button-text="buttonText"
      @add="buttonMethod"
      hide-button-icon
    >
      <p v-if="!totalFollowUps" class="fus--empty">This lead has never been in a follow up sequence</p>

      <div v-else-if="activeFollowUps.length">
        <h3 class="active_fus--heading">Lead in active follow up</h3>

        <follow-up-item v-for="activeFollowUp in activeFollowUps" :key="activeFollowUp.id" :follow-up="activeFollowUp"></follow-up-item>
      </div>
      <p v-else-if="!activeFollowUps.length" class="fus--empty mb-100">There is no active follow up</p>

      <template v-slot:expanded>
        <div v-if="otherFollowUps.length">
          <h4 class="fus--heading">Past Follow Ups</h4>

          <follow-up-item
            v-for="followUp in otherFollowUps"
            :key="followUp.id"
            :follow-up="followUp"
          ></follow-up-item>
        </div>
        <p v-else class="fus--empty">This are no past follow up sequences</p>

        <div v-if="nextPageUrl" class="flex flex-centered mt-150">
          <button-outlined @click="loadMoreFus" :loading="isLoadingMore">Load More Sequences</button-outlined>
        </div>
      </template>
    </section-collapseable>

    <section-collapseable
      v-else
      title="Follow Up Sequences"
      default-expanded
    >
      <h4 class="no_follow_up--heading">Upgrade Required</h4>
      <p class="no_follow_up--message">Please <a @click="openBillingPortal">upgrade</a> your subscription in order to get follow up sequences for your leads</p>
    </section-collapseable>

    <!-- Put In Follow Up Modal -->
    <modal-container v-if="hasFollowUpSequenceFeature">
      <modal-crud-form
        ref="putInFollowUpModal"
        title="Follow Up"
        form-component="record-follow-up-sequence-form"
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import FollowUpItem from "../components/FollowUpItem";
import {ENUMS} from "../../../services/enums";
import api from "../../../api";

export default {
  name: "LeadFollowUp",
  components: {FollowUpItem},
  data() {
    return {
      nextPageUrl: null,
      isLoadingMore: false,
    }
  },
  computed: {
    hasFollowUpSequenceFeature() {
      return this.$store.state.accounts.features.FollowUpSequence;
    },
    activeRecord() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord : {
        contacts: [],
        recordStatuses: [],
        followUpSequences: []
      };
    },
    primaryContact() {
      return this.$store.state.activeRecord.contacts.find(contact => contact.id === this.activeRecord.record.primary_contact_id);
    },
    activeStatus() {
      return this.activeRecord.recordStatuses.find(status => {
        return status.is_active && status.status_state === ENUMS.StatusStateEnum.Active.value;
      });
    },
    followUps() {
      if (!this.$store.state.activeRecord.followUpSequences.data) return [];

      this.nextPageUrl = this.$store.state.activeRecord.followUpSequences.links.next;

      return this.activeRecord.followUpSequences.data;
    },
    totalFollowUps() {
      return (this.activeRecord.followUpSequences.meta) ? this.activeRecord.followUpSequences.meta.total : 0;
    },
    otherFollowUps() {
      return this.followUps.filter(followUp => !this.isActiveFollowUp(followUp));
    },
    activeFollowUps() {
      return this.followUps.filter(followUp => this.isActiveFollowUp(followUp));
    },
    buttonText() {
      if (! this.activeFollowUps.length) return "Put In Follow Up Sequence";

      return null;
    },
  },
  methods: {
    isActiveFollowUp(followUp) {
      const activeStatus = ENUMS.FollowUpSequenceStatusEnum.Active.value;
      const pausedStatus = ENUMS.FollowUpSequenceStatusEnum.Paused.value;

      return followUp.status === activeStatus || followUp.status === pausedStatus;
    },
    buttonMethod() {
      return this.$refs.putInFollowUpModal.open();
      // if (!this.activeFollowUps) this.$refs.putInFollowUpModal.open();
    },
    loadMoreFus() {
      this.isLoadingMore = true;
      return api.custom.get(this.nextPageUrl)
        .then(res => {
          const copy = this.$utils.clone(this.followUps);
          const newData = {
            data: [...copy, ...res.data.data],
            links: res.data.links,
            meta: res.data.meta
          }

          this.$store.commit("setActiveRecordProp", {prop: 'followUpSequences', value: newData});
          this.nextPageUrl = res.data.links.next;
        })
        .finally(() => this.isLoadingMore = false)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.is_in_follow_up {
  border-left: 4px solid $primary;
}

.active_fus {

  &--heading {
    margin-bottom: 12px; // 3px;
    color: $text-muted;
    font-weight: bold;
    font-size: 0.9rem;
  }

  &--description {
    margin-bottom: 12px;
    color: $text-muted;
    font-size: 0.8rem;
    line-height: 1.3;
  }
}

.fus--heading {
  margin: -0.5rem 0 10px;
}

.fus--empty {
  margin-top: 0.75rem;
  padding: 0 1rem;
  color: $text-muted;
  font-style: italic;
  line-height: 1.3;
}

.no_follow_up {

  &--heading {
    margin:  1rem 0 6px;
    font-size: 1.125rem;
    color: $text-muted;
  }

  &--message {
    color: $text-light;
    line-height: 1.4;
  }
}
</style>
